import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const pathnameLowerCase = location.pathname.toLowerCase();

    const categories = state.data.categories;
    const catIds = Object.keys(categories.byId) || [];
    const redirectToCategory = categories.byId[catIds[0]];
    const path =
        pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/")
            ? undefined
            : redirectToCategory?.path;
    return {
        redirectUrl: path,
    };
};
type Props = WidgetProps & HasHistory & ReturnType<typeof mapStateToProps>;

const styles = {
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

const GAIALoader: React.FC<Props> = ({ history, redirectUrl }) => {
    React.useEffect(() => {
        if (redirectUrl) {
            history.replace(redirectUrl);
        }
    });
    return (
        <StyledWrapper {...styles.centeringWrapper}>
            <LoadingSpinner {...styles.spinner} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps)(GAIALoader)),
    definition: {
        group: "Common",
        displayName: "GAIA Redirect to Page",
    },
};

export default widgetModule;
